import {Vec2, Vec2Simple} from "../../../../Utils/ThreeJS/VectorStructs.js";
import {MapObject} from "../@MapObject.js";

export enum GuideShape {
	square = "square",
	//hexagon = "hexagon",
}

export class ObjMesh {
	static GetSelected(obj: MapObject): ObjMesh|n {
		//return obj.meshes?.find(a=>a.selected) ?? obj.meshes?.[0];
		return obj.meshes?.find(a=>a.selected);
	}
	constructor(data: Partial<ObjMesh>) { Object.assign(this, data); }

	selected = true;

	/** When true, the mesh is not rendered in the map-ui. UI: a "Render" checkbox — checking it deletes this field; unchecking sets it to true. */
	renderDisabled?: boolean|n;

	// geometry
	zOffset: number|n;
	points: Vec2Simple[] = [];

	// styling
	color: number[]|n;
	opacity?: number|n; // opacity of the mesh, 0-1
	texture_id: string|n;
	texture_size: Vec2|n;
	texture_rotation: number|n; // rotation in degrees (clockwise)

	// others
	guide_shape: GuideShape|n;
	guide_size: number|n;
	guide_alignPoints: boolean|n; // todo: probably remove this (this *has* to be enabled, otherwise mesh would get ridiculously complex)
}